module.exports = __webpack_public_path__ + "img/no-suppliers.d6c20524.png";